import { render, staticRenderFns } from "./OneCreative.vue?vue&type=template&id=068a34b2&scoped=true&"
import script from "./OneCreative.vue?vue&type=script&lang=js&"
export * from "./OneCreative.vue?vue&type=script&lang=js&"
import style0 from "./OneCreative.vue?vue&type=style&index=0&id=068a34b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068a34b2",
  null
  
)

export default component.exports